module.exports = __webpack_public_path__ + "static/media/78_dzz4.65eb1a6e.jpg";